'use strict';

module.exports = '3.19.1';



//////////////////
// WEBPACK FOOTER
// ./~/algoliasearch/src/version.js
// module id = 43
// module chunks = 0